import { useEffect, useState } from "react";
import api from "../../../utils/api/axiosInstance";

const useProductContextData = ({ productId }) => {
  const [nearbyStores, setNearbyStores] = useState([]);

  useEffect(() => {
    if (!productId) return;

    let cancelled = false;

    const fetchNearbyStores = async () => {
      try {
        const storesRes = await api.get(`/stores/nearby/${productId}`, {
          params: { maxDistance: 50 },
        });
        if (!cancelled) setNearbyStores(storesRes.data || []);
      } catch (err) {
        console.error("Error fetching nearby stores:", err);
        if (!cancelled) setNearbyStores([]);
      }
    };

    fetchNearbyStores();

    return () => {
      cancelled = true;
    };
  }, [productId]);

  return {
    nearbyStores,
  };
};

export default useProductContextData;
